export default "__VITE_ASSET__DtaZtlup__"